import { render, staticRenderFns } from "./EpisodeCard.vue?vue&type=template&id=47b2b16e&scoped=true&"
import script from "./EpisodeCard.vue?vue&type=script&lang=js&"
export * from "./EpisodeCard.vue?vue&type=script&lang=js&"
import style0 from "./EpisodeCard.vue?vue&type=style&index=0&id=47b2b16e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b2b16e",
  null
  
)

export default component.exports